import * as React from 'react';
import Stack from '@mui/material/Stack';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import Check from '@mui/icons-material/Check';
import {StepIconProps} from '@mui/material/StepIcon';
import {AccountCircle, ArrowBack, ArrowForward, AttachMoney, Paid, UploadFileSharp} from '@mui/icons-material';
import Fab from '@mui/material/Fab';
import {RenderContainer} from '../..';
import {Form, Formik} from 'formik';
import {AdminService, WLOCreditAPIService} from '../../../services';
import toast from 'react-hot-toast';
import {useIntl} from "react-intl";
import Moment from 'moment';
import {AppRoutes} from "../../../Router";
import {useNavigate} from "react-router-dom";
import {useRequestContext} from '../../../hooks/useRequestContext';
import {useLoginContext} from '../../../hooks/useLoginContext';
import _ from 'lodash';
import {ColorlibConnector, ColorlibStepIconRoot, Item, renderTypeIdentification} from "../../../utils/utils";
import { WloCreditoService } from '../../../types';
import { useState } from 'react';
import { Authorizations } from '../../Steps/RequestInfo/Modalconfirm/Authorizations';
import { ClockLoader } from 'react-spinners';

interface WizardsProps {
    steps: ({key: string, label: string, initialValues: any, validationSchema: any})[];
    setPopup: React.Dispatch<React.SetStateAction<string>>;
}

export function Wizard(props: WizardsProps) {
    const { steps,setPopup } = props;
    const {user} = useLoginContext();
    const [activeStep, setActiveStep] = React.useState(0);
    const {request, setRequest} = useRequestContext();
    const navigate = useNavigate();
    const intl = useIntl();
    const [isLoadingInfo, setIsLoadingInfo] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [authorizationsAccepted, setAuthorizationsAccepted] = useState(false);


    React.useEffect(()=>{
      
      
    },[activeStep])

    const handleNext = async (values: any) => {
        console.log("activeStep ", activeStep)
        if (activeStep === 0) {
           
            try {
                    if (!request.errorConsulta) {
                        if (!request.numSol) {

                            const datosPersonaString = sessionStorage.getItem("personaValidada");
                            let isPJurica;
                            if (datosPersonaString) {
                                const datosPersona = JSON.parse(datosPersonaString);
                                const numTipoDoc = datosPersona.tipIdenVal;
                                if (numTipoDoc) {
                    
                                    //renderTypeIdentification("NIT")
                                    isPJurica =  numTipoDoc == renderTypeIdentification("NIT");
                                }
                            }
                            
                            const dateSolicitud = Moment(new Date()).format('MM/DD/YYYY');
                            let codVendedor = sessionStorage.getItem('User');
                            let cVendedor;
                            let idProducto=sessionStorage.getItem('idProdc');
                            if(JSON.parse(codVendedor!).idProfile =='2'){
                                 cVendedor = ''
                            }else{
                                cVendedor = JSON.parse(codVendedor!).idUser;
                            }
                            const result = await WLOCreditAPIService.addSolicitud({
                                Pws_ident_vende: cVendedor,
                                Pws_Identificacion: values.Pws_Identificacion,
                                Pws_Tip_Identificacion: values.Pws_Tip_Identificacion,
                                Pws_Val_cuoini: values.Pws_Val_cuoini,
                                Pws_Val_cuo: request.valueOfQuote,
                                Pws_Val_finan: request.valueToFinance,
                                Pws_Correo: values.Pws_Correo,
                                Pws_Apellidos1: values.Pws_Apellidos1,
                                Pws_Apellidos2: values.Pws_Apellidos2,
                                Pws_Telefono1: values.Pws_Telefono1,
                                Pws_Telefono2: values.Pws_Telefono2,
                                Pws_Nombres: isPJurica ? values.Pws_Nom_socie : values.Pws_Nombres,
                                Pws_Val_pla: values.pws_nro_cuotas,
                                Pws_fec_solicitud: dateSolicitud,
                                Pws_Tip_Estado: "1", // Valor constante 1 Simulador S
                                Pws_Tip_Perfil: user.idProfile,
                                Pws_Tip_Person: isPJurica ? "J": "N" , //
                                Pws_linea_credito:values.pws_cod_credi,
                                Pws_Periodic:values.Pws_Val_pla, //Valor que pide el ws pero a nivel de UI no existe
                                Pws_Cod_prod:String(1),
                            });
                            console.dir(result)
                            if (result.payload.result === "1") {
                                const solicitudResult = await WLOCreditAPIService.addSolicitud({
                                    Pws_Identificacion: values.Pws_Identificacion,
                                    Pws_Tip_Identificacion: values.Pws_Tip_Identificacion
                                });
                                console.log(solicitudResult);
                                
                                const numSolicitud = solicitudResult.payload.data.Datos_Sol.Datos_Sol[0].Pws_num_solicitud;
                                setRequest({
                                    ...request,
                                    numIdentification: values.Pws_Identificacion,
                                    typeIdentification: values.Pws_Tip_Identificacion,
                                    numSol: numSolicitud,
                                    email: values.Pws_Correo,
                                    phoneNumber: values.Pws_Telefono1,
                                    dateSol: dateSolicitud
                                });
                                ////
                                toast.success('Hemos generado una nueva solicitud');
                                setActiveStep((prevActiveStep) => prevActiveStep + 1);
                            }else{
                                toast.error('No es posible continuar con el proceso');

                            }
                        }
                        else {
                            setActiveStep((prevActiveStep) => prevActiveStep + 1);
                        }
                    }
                    else {
                        toast.error('No es posible validar su identidad');
                    }
            } catch (e) {
                toast.error('En este momento no podemos atender su solicitud');
                setTimeout(() => {
                }, 4000);
            }

      
        }

        if (activeStep === 1) {            
            try {

                //AGREGAR CONDICIONAL PARA CONSUMOS DE WS CUANDO ES PERSONA JURIDICA
                //CREAR PERSONA Y REPRESENTANTE LEGAL
                const datosPersonaString = sessionStorage.getItem("personaValidada");
                let isPJurica;
                if (datosPersonaString) {
                    const datosPersona = JSON.parse(datosPersonaString);
                    const numTipoDoc = datosPersona.tipIdenVal;
                    if (numTipoDoc) {
        
                        //renderTypeIdentification("NIT")
                        isPJurica =  numTipoDoc == renderTypeIdentification("NIT");
                    }
                }
                if(!isPJurica){
                    console.log("ENTRO A PERSONA NATURAL")
                    const personaRequest = {
                        Pws_i_codigo: values.Pws_i_codigo,
                        Pws_Identificacion: values.Pws_Identificacion,
                        Pws_Tip_Identificacion: values.Pws_Tip_Identificacion,
                        Pws_Tip_Estado: "2", // Valor constante para confirmación de información.
                        Pws_Tip_Perfil:request.searchANI?"2":request.personCygnus?.Pws_Tip_Perfil,
                        Pws_Tip_person: values.Pws_Tip_person,
                        Pws_Tip_ocupa: values.Pws_Tip_ocupa,
                        Pws_Nombres: values.Pws_Nombres!,
                        Pws_Apellidos1: values.Pws_Apellidos1! ,
                        Pws_Apellidos2: values.Pws_Apellidos2! ,
                        Pws_Telefono1: values.Pws_Telefono1,
                        Pws_Telefono2: values.Pws_Telefono2,
                        Pws_Correo: values.Pws_Correo,
                        Pws_Fec_expe:  Moment(values.Pws_Fec_expe!).format('MM/DD/YYYY') ,
                        Pws_Lugar_exp: values.Pws_Lugar_exp! ,
                        Pws_Fec_nacime:  Moment(values.Pws_Fec_nacime!).format('MM/DD/YYYY'),
                        Pws_Estado_Civil: values.Pws_Estado_Civil,
                        Pws_Direccion_res: values.Pws_Direccion_res,
                        Pws_Departamento: values.Pws_Departamento,
                        Pws_Ciudad_res: values.Pws_Ciudad_res,
                        Pws_Genero: values.Pws_Genero,
                        Pws_Estrato_per: values.Pws_Estrato_per,
                        Pws_Per_cargo: values.Pws_Per_cargo,
                        Pws_Tip_vivienda: values.Pws_Tip_vivienda,
                        Pws_Niv_estudio: values.Pws_Niv_estudio,
                        Pws_Nom_empre: values.Pws_Nom_empre,
                        Pws_fec_ingemp:  Moment(values.Pws_fec_ingemp!).format('MM/DD/YYYY'),
                        Pws_Fideliza: values.Pws_Fideliza,
                        Pws_Tip_contra: values.Pws_Tip_contra,
                        Pws_Ant_labo: values.Pws_Ant_labo,
                        Pws_Car_emp: values.Pws_Car_emp,
                        Pws_Nom_Jefedi: values.Pws_Nom_Jefedi,
                        Pws_Direc_emp: values.Pws_Direc_emp,
                        Pws_Ciud_emp: values.Pws_Ciud_emp,
                        Pws_tel_emp1: values.Pws_tel_emp1,
                        Pws_tel_emp2: values.Pws_tel_emp2,
                    }

                        console.log(request?.searchANI)
                        if (request?.searchANI) {
                                const result = await WLOCreditAPIService.addSolicitudPersona(personaRequest);
                                if (!_.isEmpty(result.payload)) {
                                    if (result.payload.result > 0) {
                                        toast.success('Hemos generado una nueva solicitud persona');
                                        setActiveStep((prevActiveStep) => prevActiveStep + 1);
                                    } else {
                                        toast.error(result.payload.message);
                                    }
                                }
                                
                        } else {
                                const resultConsultaPersona = await WLOCreditAPIService.consultaSolicitudCygnus({Pws_Identificacion: values.Pws_Identificacion,
                                    Pws_Tip_Identificacion: values.Pws_Tip_Identificacion});
                                if (!_.isEmpty(resultConsultaPersona.payload)) {
                                    const personaConsultaResult = resultConsultaPersona.payload.data.datos_persona.Datos_persona[0];
                                    const infoUpdatePerson = {...personaRequest, Pws_i_codigo: personaConsultaResult ? personaConsultaResult.Pws_i_codigo : 0};
                                    const resultUpdatePersona = await WLOCreditAPIService.addSolicitudPersona(infoUpdatePerson);
                                    if (resultUpdatePersona.payload.result > 0) {
                                        setActiveStep((prevActiveStep) => prevActiveStep + 1);
                                        //Preguntar si efectivamente se creo.
                                        toast.success('Hemos actualizado su solicitud persona');
                                    } else {
                                        toast.error('No hemos podido completar tu solicitud.');
                                    }
                                }
                        }
                }else{
                    console.log("ENTRO A PERSONA JURIDICA")
                    const repLegalRequest = {
                        Pws_i_codigo: values.Pws_Rep_Legal_I_Codigo,
                        Pws_Identificacion: values.Pws_Rep_Legal_Identificacion,
                        Pws_Tip_Identificacion: values.Pws_Rep_Legal_Tipo_ID,
                        Pws_Tip_Estado: "2", // Valor constante para confirmación de información.
                        Pws_Tip_Perfil: user.idProfile,
                        Pws_Tip_person: "N",
                        Pws_Nombres: values.Pws_Rep_Legal_Nombres!,
                        Pws_Apellidos1: values.Pws_Rep_Legal_Apellidos!,
                        Pws_Telefono1: values.Pws_Rep_Legal_Telefono,
                        Pws_Correo: values.Pws_Rep_Legal_Correo,
                        Pws_Fec_expe:  Moment(values.Pws_Rep_Legal_Fecha_Exp!).format('MM/DD/YYYY') ,
                        Pws_Lugar_exp: values.Pws_Rep_Legal_Lugar_Exp! ,
                        Pws_Direccion_res: values.Pws_Rep_Legal_Direccion,
                        Pws_Ciudad_res: values.Pws_Rep_Legal_Ciudad,
                    }
                    
                    const personaJRequest = {
                        Pws_i_codigo: values.Pws_i_codigo,
                        Pws_Identificacion: values.Pws_Identificacion,
                        Pws_Tip_Identificacion: values.Pws_Tip_Identificacion,
                        Pws_Tip_Perfil:request.searchANI?"2":request.personCygnus?.Pws_Tip_Perfil,
                        Pws_Tip_person: 'J',
                        Pws_Nom_socie: values.Pws_Nom_socie,
                        Pws_Fec_cre: values.Pws_Fec_cre,
                        Pws_Cod_ciu: values.Pws_Cod_ciu,
                        Pws_act_eco: values.Pws_act_eco,
                        Pws_tip_emp: values.Pws_tip_emp,
                        Pws_iden_rep_legal: values.Pws_Rep_Legal_Identificacion,
                        Pws_Act_finan: values.Pws_Act_finan,
                        Pws_Pasiv_finan: values.Pws_Pasiv_finan,
                        Pws_ingres_finan: values.Pws_ingres_finan,  
                        Pws_egres_finan: values.Pws_egres_finan,
                        Pws_tip_contri: values.Pws_tip_contri,
                        Pws_auto_rete: values.Pws_auto_rete,
                        Pws_ret_iva: values.Pws_ret_iva,
                        ps_direccion: values.Pws_Direccion,
                        ps_ciudad: values.Pws_Ciudad,
                        //Se agregan los campos para los medios de comunicacion de la persona juridica
                        Pws_telefono: values.Pws_Telefono1,
                        Pws_correo: values.Pws_Correo,
                    }
                    // console.log("personaJRequest",personaJRequest)

                    // if (request?.searchANI) {
                        const result = await WLOCreditAPIService.addSolicitudPersona(repLegalRequest);
                        if (!_.isEmpty(result.payload)) {
                            console.log("prueba")
                            if (result.payload.result > 0) {
                                toast.success('Hemos generado una nueva solicitud persona');
                                //setActiveStep((prevActiveStep) => prevActiveStep + 1);
                            } else {
                                toast.error(result.payload.message);
                            }
                            console.log("pre addsolicitud PJ")
                            try {
                                const result2 = await WLOCreditAPIService.addSolicitudPJ(personaJRequest);
                                console.log("result2",result2)
                                if (!_.isEmpty(result2.payload)) {
                                    if (result2.payload.result > 0) {
                                        toast.success('Hemos generado una nueva solicitud persona J');
                                        setActiveStep((prevActiveStep) => prevActiveStep + 1);
                                    } else {
                                        toast.error(result2.payload.message);
                                    }
                                }
                            } catch (error) {
                                console.log("error",error)
                            }
                           
                        }

                       
                            
                    // } else {
                    //     const resultConsultaPersona = await WLOCreditAPIService.consultaSolicitudCygnus({Pws_Identificacion: values.Pws_Identificacion,
                    //         Pws_Tip_Identificacion: values.Pws_Tip_Identificacion});
                    //     if (!_.isEmpty(resultConsultaPersona.payload)) {
                    //         const personaConsultaResult = resultConsultaPersona.payload.data.datos_persona.Datos_persona[0];
                    //         const infoUpdatePerson = {...repLegalRequest, Pws_i_codigo: personaConsultaResult ? personaConsultaResult.Pws_i_codigo : 0};
                    //         const resultUpdatePersona = await WLOCreditAPIService.addSolicitudPersona(infoUpdatePerson);
                    //         if (resultUpdatePersona.payload.result > 0) {

                    //             ///////////////////////////////////////////////////
                    //             ///////////////////////////////////////////////////
                    //             setActiveStep((prevActiveStep) => prevActiveStep + 1);
                    //             //Preguntar si efectivamente se creo.
                    //             toast.success('Hemos actualizado su solicitud persona');
                    //         } else {
                    //             toast.error('No hemos podido completar tu solicitud.');
                    //         }
                    //     }


                    //     const resultConsultaPj = await WLOCreditAPIService.consultaSolicitudPJ({Pws_Identificacion: values.Pws_Identificacion,
                    //         Pws_Tip_Identificacion: values.Pws_Tip_Identificacion});
                    //     if (!_.isEmpty(resultConsultaPersona.payload)) {
                    //         const personaConsultaResult = resultConsultaPersona.payload.data.datos_persona.Datos_persona[0];
                    //         const infoUpdatePerson = {...repLegalRequest, Pws_i_codigo: personaConsultaResult ? personaConsultaResult.Pws_i_codigo : 0};
                    //         const resultUpdatePersona = await WLOCreditAPIService.addSolicitudPersona(infoUpdatePerson);
                    //         if (resultUpdatePersona.payload.result > 0) {

                    //              ///////////////////////////////////////////////////
                    //             ///////////////////////////////////////////////////
                    //             setActiveStep((prevActiveStep) => prevActiveStep + 1);
                    //             //Preguntar si efectivamente se creo.
                    //             toast.success('Hemos actualizado su solicitud persona');
                    //         } else {
                    //             toast.error('No hemos podido completar tu solicitud.');
                    //         }
                    //     }
                    // }
                }
            } catch (e) {
                toast.error('En este momento no podemos atender su solicitud');
                setTimeout(() => {
                }, 4000);
                console.log(e);
            }

        }

        if (activeStep === 2) {
            //AGREGAR CONDICIONAL PARA CONSUMOS DE WS CUANDO ES PERSONA JURIDICA
            //luego de guardar los documentos debe aceptar las condiciones y continuar el flujo de creacion de credito
            try {
                const operFinancieras = {
                    s_num_solicitud: request.numSol!,
                    s_identificacion: values.Pws_Identificacion,
                    s_tipo_identificacion: values.Pws_Tip_Identificacion,
                    s_ingreso_principal: values.s_ingreso_principal,
                    s_otros_ingresos: values.s_otros_ingresos,
                    s_otros_egresos: values.s_otros_egresos,
                    s_arriendo: values.s_arriendo,
                    s_concep_otr_ingre: values.s_concep_otr_ingre,
                    s_declarante_ren: values.s_declarante_ren ? "1" : "0",
                    s_moneda_ext: values.s_moneda_ext ? "1" : "0",
                    s_monext_oper: values.s_monext_oper,
                    s_tip_monext: values.s_tip_monext,
                    s_cuent_ext: values.s_cuent_ext ? "1" : "0",
                    s_cuen_extban: values.s_cuen_extban,
                    s_cuen_extnum: values.s_cuen_extnum,
                    s_cuen_extpais: values.s_cuen_extpais,
                    s_cuen_extciudad: values.s_cuen_extciudad
                }
                const valorfinancial=await WLOCreditAPIService.addFinancialInformation(operFinancieras);
                const peps = {
                    s_num_solicitud: request.numSol!,
                    s_identificacion: values.Pws_Identificacion,
                    s_tipo_identificacion: values.Pws_Tip_Identificacion,
                    s_pep_recpublic: values.s_pep_recpublic ? "1" : "0",
                    s_pep_poderpublic: values.s_pep_poderpublic ? "1" : "0",
                    s_pep_reconpublic: values.s_pep_reconpublic ? "1" : "0",
                    s_pep_pubexpue: values.s_pep_pubexpue ? "1" : "0",
                    s_pep_seggraconsa: values.s_pep_seggraconsa ? "1" : "0",
                    s_pep_nompepseg: values.s_pep_nompepseg,
                    s_pep_paren: values.s_pep_paren,
                    s_pep_identif: values.s_pep_identif,
                }
                const result = await WLOCreditAPIService.addPeps(peps);
               //Preguntar si efectivamente se creo.
                setActiveStep((prevActiveStep) => prevActiveStep + 1);
                toast.success('Hemos añadido la información financiera a su solicitud.');
            } catch (e) {
                toast.error('En este momento no podemos atender su solicitud');
                setTimeout(() => {
                }, 4000);
            }
        }

        if (steps[activeStep]?.key === 'reference_information') {
            if(valorCheck()){
                setActiveStep((prevActiveStep) => prevActiveStep + 1);
            }else{
                    toast.error('Debes completar los documentos Adjuntos');
            }
        }
    };
    const valorCheck = (): boolean => {        
        let letValorAceptado = true;
        const fileInputs = document.getElementsByName("file-input");
        for (let i = 0; i < fileInputs.length; i++) {
            console.log("archivos")
        
            console.log(fileInputs[i])
          
            const valor = fileInputs[i] as HTMLInputElement;
           

            let dataId = fileInputs[i].dataset.id as any;
            console.log(dataId)
            if(dataId == 2){
                continue;
            }
            if (valor.files && valor.files.length === 0) {
                letValorAceptado = false; // Si algún elemento tiene 0 archivos, cambia a falso (false)
                break; // Salimos del bucle, ya que no es necesario seguir verificando
            }
        }
    
        return letValorAceptado;
    };
    const isLastStep = () => {
      
        return activeStep === steps.length - 1;
    };

    const handleAuthorizations = () => {
        if (!authorizationsAccepted) {
            setShowModal(true);
        }
    };

    const handleAcceptAuthorizations = () => {
        setAuthorizationsAccepted(true);
        setShowModal(false);
    };

    const onSubmit = async (values: any, formikBag: { setSubmitting: any; }) => {
        const {setSubmitting} = formikBag;
        if (!isLastStep()) {
            if(activeStep == 0){
                if(values.Pws_Correo==values.mail_confirmation){  
                    setIsLoading(true);
                    handleNext(values).finally(() => {
                        setIsLoading(false);
                        setSubmitting(false);
                    });
                    return;
                }else{
                    toast.error('No puede continuar los correos no coincide');
        
                }
            }else{
                setIsLoading(true);
                handleNext(values).finally(() => {
                    setIsLoading(false);
                    setSubmitting(false);
                });
                return;
            }
           
        } else {
                if (steps[activeStep]?.key === 'reference_information' && !valorCheck()) {
                    toast.error('Debes completar los documentos Adjuntos');
                    setSubmitting(false);
                    return;
                }
                if (!authorizationsAccepted) {
                    setIsLoading(false);
                    handleAuthorizations();
                    setSubmitting(false);
                    return;
                }
                //Se agrega el consumo para enviar correo, se debe validar si es domicializado o pse
                
                const datosPersonaString = sessionStorage.getItem("personaValidada");
                let isPJurica;
                
                if (datosPersonaString) {
                    const datosPersona = JSON.parse(datosPersonaString);
                    const numTipoDoc = datosPersona.tipIdenVal;
                    if (numTipoDoc) {
        
                        //renderTypeIdentification("NIT")
                        isPJurica =  numTipoDoc == renderTypeIdentification("NIT");
                    }
                }
                console.log("ENTRO AL ELSE EN ONSUBMIT")
                if(!isPJurica){
                    const cygnus=await WLOCreditAPIService.grabar_cignus({
                        Pws_Identificacion :values.Pws_Identificacion,
                        Pws_Tip_Identificacion:values.Pws_Tip_Identificacion,
                        Pws_Tip_Perfil:"2"
                    })
                }
                setIsLoading(true);
                //NR
                //consulta solicitud 
                const solicitudResulado = await WLOCreditAPIService.addSolicitud({
                    Pws_num_solicitud:String(request.numSol!),
                    Pws_Identificacion: values.Pws_Identificacion,
                    Pws_Tip_Identificacion: values.Pws_Tip_Identificacion

                });
                
                sessionStorage.setItem('num_solicitud', solicitudResulado.payload.data.Datos_Sol.Datos_Sol[0].Pws_num_solicitud);
                sessionStorage.setItem('correo',values.Pws_Correo );
                sessionStorage.setItem('tel',values.Pws_Telefono );

                let codProducto = sessionStorage.getItem('CodProducto')!;
                let flujo;

                if(isPJurica && codProducto == '2'){
                    flujo = 'SEGUROS_PJ';

                }else{
                    if(codProducto == '1'){
                        flujo = 'LIBRE_INV';
                    }else if(codProducto == '2'){
                        flujo = 'SEGUROS';
                    }
                }
               

                if(Number(solicitudResulado.payload.result)>0){

                    if(solicitudResulado.payload.data.Datos_Sol.Datos_Sol[0].Pws_Tip_Estado != 5){

                        let personaCifin = {
                            numIdentificacion: "",
                                tipoIdentificacion: "",
                            }

                        let estadoCredito;

                        if(isPJurica){
                           
                            personaCifin = {
                                numIdentificacion: values.Pws_Rep_Legal_Identificacion,
                                tipoIdentificacion: values.Pws_Rep_Legal_Tipo_ID,
                            }
                        }else{
                             personaCifin = {
                                numIdentificacion: values.Pws_Identificacion,
                                tipoIdentificacion: values.Pws_Tip_Identificacion,
                            }
                            // solicitudResulado.payload.data.Datos_Sol.Datos_Sol[0].Pws_Tip_Estado = "12";
                            // estadoCredito = "L";
                        }
                        
                        const Respuestapuntaje = await WLOCreditAPIService.consultaCifin(personaCifin);
                        let puntaje = Respuestapuntaje.puntajeCifin;
                        let monto = values.Pws_Val_monto;
                        
                        console.log("MONTOOOOOOOO", monto)
                        console.log(values.Pws_Val_monto)
                        if (monto < 10000000 && puntaje > 600 && flujo == 'SEGUROS') {
                            solicitudResulado.payload.data.Datos_Sol.Datos_Sol[0].Pws_Tip_Estado = "4";
                            estadoCredito = "A";
                        } else {
                            solicitudResulado.payload.data.Datos_Sol.Datos_Sol[0].Pws_Tip_Estado = "2";
                            estadoCredito = "L";
                        }

                           // hace el llamado para guardar el puntaje en el WS
                        await WLOCreditAPIService.guardarPuntajeCifin({
                            Pws_num_solicitud: solicitudResulado.payload.data.Datos_Sol.Datos_Sol[0].Pws_num_solicitud,
                            Pws_Identificacion: personaCifin.numIdentificacion,
                            Pws_Tip_Identificacion: personaCifin.tipoIdentificacion,
                            Pws_Fec_gen: Moment(new Date()).format('MM/DD/YYYY'),
                            Pws_estado_resotp: "1",
                            Pws_Tip_val: "2",
                            Pws_Puntaje: puntaje,
                            Pws_Entidad_Consul: "3",
                            Pws_Num_cuodat: null,
                            Pws_Xml_Dc: Respuestapuntaje.xData
                        });

                       
                        
                        // solicitudResulado.payload.data.Datos_Sol.Datos_Sol[0].Pws_Tip_Estado="4" //Pws_Tip_Estado=4 APROBADO 12= EN ESTUDIO 2=PENDIENTE
                         //NR
                        //GUARDA SOLICITUD 
                        const solicitudResulados = await WLOCreditAPIService.addSolicitud(solicitudResulado.payload.data.Datos_Sol.Datos_Sol[0])                            

                     /*    console.log('Guardando puntaje en regDatacre:', {
                            Pws_Identificacion: personaCifin.numIdentificacion,
                            Pws_Tip_Identificacion: personaCifin.tipoIdentificacion,
                            Pws_num_solicitud: solicitudResulado.payload.data.Datos_Sol.Datos_Sol[0].Pws_num_solicitud,
                            Pws_Puntaje: puntaje,
                        }); */
                        
                     


                        let tipodocumento = "";

                        if (values.Pws_Tip_Identificacion === '4') tipodocumento = 'ti';
                        if (values.Pws_Tip_Identificacion === '1') tipodocumento = 'cc';
                        if (values.Pws_Tip_Identificacion === '5') tipodocumento = 'ce';
                        if (values.Pws_Tip_Identificacion === '3') tipodocumento = 'nit';
                        if (values.Pws_Tip_Identificacion === '2') tipodocumento = 'pa';
        
                        // consulta sagrilaft
                        const data = {
                            datoConsultar: values.Pws_Identificacion!, //19123402
                            tipoDocumento: tipodocumento,
                            numeroSolicitud: request.numSol!, 
                            fechaSolicitud: Moment(new Date()).format('MM/DD/YYYY'),
                            email: `${values.Pws_Correo!}`,
                        };

                        // Consulta consolidada deshabilitada para evitar consumo.
                        // const response = await WLOCreditAPIService.consultaConsolidada(data);
                        let sagrilaftRiesgo = '0';
                        let presentaRiesgos = false;

                        // Guarda Sagrilaft (deshabilitado)
                        // const response2 = await WLOCreditAPIService.regDataCreditoAndSagrilaft({
                        //     Pws_num_solicitud: request.numSol!,
                        //     Pws_Identificacion: values.Pws_Identificacion!,
                        //     Pws_Tip_Identificacion: values.Pws_Tip_Identificacion!,
                        //     Pws_Fec_gen: Moment(new Date()).format('MM/DD/YYYY'),
                        //     Pws_estado_resotp: sagrilaftRiesgo,
                        //     Pws_Tip_val: '1',
                        //     Pws_Puntaje: '0',
                        //     Pws_Entidad_Consul: '2',
                        //     Pws_Num_cuodat: '',
                        //     Pws_Xml_Dc: '',
                        // });

                        // Consumo Score Cygnus y guardado del puntaje
                        const responseScore = await WLOCreditAPIService.EvaluaScore({
                            ps_radicado: String(request.numSol!),
                            ps_identificacion: String(values.Pws_Identificacion),
                            ps_cod_lin: String(values.pws_cod_credi),
                            ps_tipoCliente: '1',
                            ps_tip_deucode: '2',
                        });
                        const scorepuntaje = responseScore.payload.data.puntaje_obtenido;
                        const estadocygnus = scorepuntaje >= 51 ? '0' : '1';
                        const data6 = {
                            Pws_num_solicitud: request.numSol!,
                            Pws_Identificacion: values.Pws_Identificacion!,
                            Pws_Tip_Identificacion: values.Pws_Tip_Identificacion!,
                            Pws_Fec_gen: Moment(new Date()).format('MM/DD/YYYY'),
                            Pws_estado_resotp: estadocygnus,
                            Pws_Tip_val: '4',
                            Pws_Puntaje: String(scorepuntaje),
                            Pws_Entidad_Consul: '5',
                            Pws_Num_cuodat: '',
                            Pws_Xml_Dc: '',
                        };
                        await WLOCreditAPIService.regDataCreditoAndSagrilaft(data6);
                        

                        //CREA CREDITO

                        console.log("CREA CREDITO ",  {
                                pws_monto: values.Pws_Val_finan,
                                pws_nro_cuotas: values.pws_nro_cuotas!,
                                pws_fecha_sol: Moment(new Date()).format('MM/DD/YYYY'),
                                pws_val_recog: "",
                                pws_fecha_prox_pag: "",
                                pws_cod_credi: values.pws_cod_credi,
                                pws_form_plazo: values.Pws_Val_pla,
                                pws_identific: values.Pws_Identificacion,
                                pws_form_periodic: values.Pws_Val_pla,
                                pws_val_tf1: "",
                                pws_fec_tf1: "",
                                pws_val_tf2: "",
                                pws_fec_tf2: "",
                                pws_val_tf3: "",
                                pws_fec_tf3: "",
                                pws_num_solicitud: request.numSol!,
                                pws_estado_credito: estadoCredito,
                                pws_estado_solicitud: estadoCredito,
                                pws_descripcion:request.numSol!,
                                pws_porcentajes_radic: ""
                            })
                            console.log(values)
                        // if(!isPJurica){
                            const creaCreditos=await WLOCreditAPIService.createCredito({
                                pws_monto: values.Pws_Val_monto,
                                pws_nro_cuotas: values.pws_nro_cuotas!,
                                pws_fecha_sol: Moment(new Date()).format('MM/DD/YYYY'),
                                pws_val_recog: "",
                                pws_fecha_prox_pag: "",
                                pws_cod_credi: values.pws_cod_credi,
                                pws_form_plazo: values.Pws_Val_pla,
                                pws_identific: values.Pws_Identificacion,
                                pws_form_periodic: values.Pws_Val_pla,
                                pws_val_tf1: "",
                                pws_fec_tf1: "",
                                pws_val_tf2: "",
                                pws_fec_tf2: "",
                                pws_val_tf3: "",
                                pws_fec_tf3: "",
                                pws_num_solicitud: request.numSol!,
                                pws_estado_credito: estadoCredito,
                                pws_estado_solicitud: estadoCredito,
                                pws_descripcion:request.numSol!,
                                pws_porcentajes_radic: ""
                            })
                        // }
                           let numRadic = creaCreditos.payload.data.R_numRadic;
                        try {
                            
                            setIsLoadingInfo(true);
                           
                            let dataPago = JSON.parse(sessionStorage.getItem('dataPago')!);
                            //let ciudad2 = localStorage.getItem("selectedCity");
                            const infoCuenta ={
                                codInfoCuenta: 0,
                                sTitular: dataPago?.esTitular ? "S" : "N",
                                nombreTitular: dataPago?.nombres + " " + dataPago?.apellidos,
                                codSolicitud: ""/* solWeb.codigoRadicado */,
                                sTipoIdent: parseInt(values.Pws_Tip_Identificacion),
                                sNumDoc: values.Pws_Identificacion,
                                cEmailCod: dataPago?.cEmailCod,
                                cNumCelular: dataPago?.cNumCelular,
                                cNumTelefono: dataPago?.cNumCelular,
                                numeroCuenta: dataPago?.metodoPago == "PSE" ? "PSE" : dataPago?.numeroCuenta,
                                banco: dataPago?.metodoPago == "PSE" ? "PSE" : dataPago?.entidadFinancieraDescripcion,
                                codTipoCuenta: dataPago?.tipoCuenta,
                                codUsuarioCreador: ""/* usuarioWeb.listUsuarios[0].ICodigo */
                            }
                                            
                            if (dataPago?.metodoPago != "PSE" ){
                                await AdminService.grabarEntidadesFin({
                                    pws_identific: values.Pws_Identificacion,
                                    pws_tipoiden: values.Pws_Tip_Identificacion,
                                    pws_entidadf: dataPago?.entidadFinanciera,
                                    pws_numcuenta: dataPago?.numeroCuenta,
                                })
                            }
                               
                            
                            let ciudad = localStorage.getItem("selectedCity");

                            const dataPN = {
                                flujo,
                                usuario: {
                                    nombres: values.Pws_Nombres,
                                    apellidos: values.Pws_Apellidos1,
                                    identificacion: values.Pws_Identificacion,
                                    telefono: values.Pws_Telefono1,
                                    email: values.Pws_Correo,
                                },
                                infoCuenta,
                                ciudad,
                                numSolicitud: request.numSol,
                                numRadic
                            };

                            const dataPj = {
                                flujo,
                                usuario: {
                                    nombres: values.Pws_Nom_socie,
                                    apellidos: "",
                                    identificacion: values.Pws_Identificacion,
                                    tipoIdentificacion: values.Pws_Tip_Identificacion,
                                    telefono: values.Pws_Telefono1,
                                    email: values.Pws_Correo,
                                    direccion: values.Pws_Direccion,
                                }, 
                                representanteLegal:{
                                    nombre: values.Pws_Rep_Legal_Nombres,
                                    apellidos: values.Pws_Rep_Legal_Apellidos,
                                    identificacion: values.Pws_Rep_Legal_Identificacion,
                                    tipoIdentificacion: values.Pws_Rep_Legal_Tipo_ID,
                                    telefono: values.Pws_Rep_Legal_Telefono,
                                },

                                ciudad: values.Pws_Rep_Legal_Lugar_Exp,
                                numSolicitud: request.numSol,
                                numRadic
                            };

                            const data = isPJurica ? dataPj : dataPN;

                            const firmaPagare = await WLOCreditAPIService.iniciarProcesoFirma(data)
                            if(!firmaPagare.payload.flag){
                                toast.error('En este momento no podemos atender su solicitud por favor intentelo nuevamente o comuniquese con nosotros.');
                                setTimeout(() => {
                                }, 4000);
                                setIsLoading(false)
                                return;
                            }

                            if(estadoCredito == "A"){
                                await WLOCreditAPIService.emailAprobado({email: values.Pws_Correo});

                            }else if(estadoCredito == "L"){
                                await WLOCreditAPIService.emailEnEstudio({email: values.Pws_Correo});
                            }

                            setIsLoadingInfo(false);
                            setIsLoading(false);
                            toast.success('Hemos finalizado con su solicitud.');
                     
                            navigate(AppRoutes.CONFIRMATION,{replace: true})
                        
                        }catch (error) {
                            console.log(error);
                            
                            toast.error('En este momento no podemos atender su solicitud');
                            setTimeout(() => {
                            }, 4000);
                            setIsLoading(false)
                        }


                    }
                    
                }else{
                    toast.error('Estamos presentando inconvenientes con la solicitud, por favor intente nuevamente.');
                    setTimeout(() => {
                    }, 4000);
                    setIsLoading(false)
                }
                        
                    // }else{
                    //     toast.error("Error al creCredito")
                    // }
                // }else{
                //     toast.error(cygnus.payload.message);           
        }
        setTimeout(() => {
            setSubmitting(false);
        }, 500);
    };

    const handleBack = () => {
        if (activeStep === 0) {
            if(sessionStorage.getItem('CodProducto')=="1"){
                navigate(AppRoutes.POLICIES, {replace: true});
            }else{
                navigate(AppRoutes.CATALOG, {replace: true});
            }
        } else {
            setActiveStep((prevActiveStep) => prevActiveStep - 1);
        }
    };



    function ColorlibStepIcon(props: StepIconProps) {
        const {active, completed, className} = props;

        const icons: { [index: string]: React.ReactElement } = {
            1: <Check/>,
            2: <AccountCircle/>,
            3: <AttachMoney/>,
            4: <UploadFileSharp/>,
            5:  <Paid/>
        };

        return (
            <ColorlibStepIconRoot ownerState={{completed, active}} className={className}>
                {completed ? <Check/> : icons[String(props.icon)]}
            </ColorlibStepIconRoot>
        );
    }

    const initialValues = steps.reduce(
        (values, {initialValues}) => ({
            ...values,
            ...initialValues
        }),
        {}
    );
  
    const validationSchema = steps[activeStep].validationSchema
    console.log("validationSchema",validationSchema)

    return (

        <div style={{ position: 'relative' }}>
             <div className={`${isLoading && !showModal ? 'spinner-overlay' : ''} spinner`}>
                <ClockLoader id='spinner' className="Spinner" color={"#00908e"} loading={isLoading && !showModal} size={100}/>
            </div>
            <Formik
                initialValues={initialValues}
                onSubmit={onSubmit}
                validationSchema={validationSchema}
            >
                {({isSubmitting, values, errors, touched}) => (
                    <>
                        <Form>
                            <Stack direction={{xs: 'column', sm: 'row'}}
                                   spacing={{xs: 1, sm: 1, md: 4}} justifyContent="space-between">
                                <Item elevation={0}>
                                    <div className="d-none d-md-none d-lg-block d-xl-block">
                                        <Fab variant="extended" color="neutral" aria-label="add"
                                             onClick={handleBack} style={{float:"left"}} className="hooverButtonRed">
                                            <ArrowBack sx={{mr: 1}} className="hooverButtonRedsvg"/>
                                            {intl.formatMessage({id: "button_back"})}
                                        </Fab>
                                    </div>
                                    <div className="d-block d-md-block d-lg-none d-xl-none">
                                        <Fab variant="extended" color="neutral" aria-label="add" 
                                             onClick={handleBack} className="hooverButtonRed"> 
                                            <ArrowBack className="hooverButtonRedsvg"/>
                                            {intl.formatMessage({id: "button_back"})}
                                        </Fab>
                                    </div>
                                </Item>
                                <Item elevation={0}>
                                    <Stepper alternativeLabel activeStep={activeStep} connector={<ColorlibConnector/>}>
                                        {steps.map((item) => (
                                            <Step key={item.label}>
                                                <StepLabel StepIconComponent={ColorlibStepIcon}>
                                                    <p className="step">{item.label}</p>
                                                </StepLabel>
                                            </Step>
                                        ))}
                                    </Stepper>
                                </Item>
                                <Item elevation={0}>
                                    <div className="d-none d-md-none d-lg-block d-xl-block">
                                        {Object.keys(errors).length > 0?<>
                                            <Fab style={{paddingLeft:"25px"}} variant="extended" color="error" aria-label="add" disabled={isSubmitting || isLoading}
                                             type="button" onClick={()=>{toast.error("Complete la data");console.log(errors)}}className="hooverButtonsubmit">
                                            {isLastStep() ?  intl.formatMessage({id: "button_process"}) : intl.formatMessage({id: "button_next"})}
                                            <ArrowForward sx={{mr: 1}} className="hooverButtonRedsvgsubmit"/>
                                        </Fab>
                                        </>:<>
                                        <Fab style={{paddingLeft:"25px"}} variant="extended" color="error" aria-label="add" disabled={isSubmitting || isLoading}
                                             type="submit"className="hooverButtonsubmit">
                                            {isLastStep() ?  intl.formatMessage({id: "button_process"}) : intl.formatMessage({id: "button_next"})}
                                            <ArrowForward sx={{mr: 1}} className="hooverButtonRedsvgsubmit"/>
                                        </Fab>
                                        </>}
                                       
                                    </div>
                                </Item>
                            </Stack>

                            <RenderContainer errors={errors} values={values} touched={touched} step={steps[activeStep].key as any} setPopup={setPopup}/>
                            {showModal && (<Authorizations showModal={showModal} onHide={() => setShowModal(false)} onAccept={handleAcceptAuthorizations}/>)}

                            <Item elevation={0} className="button-bottom-container" style={{marginTop: '30px', marginBottom: '20px', padding: '16px', textAlign: 'right'}}>
                                <div className="d-none d-md-none d-lg-block d-xl-block" style={{display: 'flex', justifyContent: 'flex-end', width: '100%', marginLeft: 'auto'}}>
                                    {Object.keys(errors).length > 0?<> 
                                        <Fab style={{paddingLeft:"25px"}} variant="extended" color="error" aria-label="add" disabled={isSubmitting || isLoading}
                                         type="button" onClick={()=>{toast.error("Complete la data");console.log(errors)}}className="hooverButtonsubmit">
                                        {isLastStep() ?  intl.formatMessage({id: "button_process"}) : intl.formatMessage({id: "button_next"})}
                                        <ArrowForward sx={{mr: 1}} className="hooverButtonRedsvgsubmit"/>
                                    </Fab>
                                    </>:<>
                                    <Fab style={{paddingLeft:"25px"}} variant="extended" color="error" aria-label="add" disabled={isSubmitting || isLoading}
                                         type="submit"className="hooverButtonsubmit">
                                        {isLastStep() ?  intl.formatMessage({id: "button_process"}) : intl.formatMessage({id: "button_next"})}
                                        <ArrowForward sx={{mr: 1}} className="hooverButtonRedsvgsubmit"/>
                                    </Fab>
                                    </>}
                                </div>
                                
                                <div className="d-block d-md-block d-lg-none d-xl-none" style={{display: 'flex', justifyContent: 'center', width: '100%', marginTop: '20px'}}>
                                {Object.keys(errors).length > 0?<> 
                                    <Fab variant="extended" style={{paddingLeft:"25px"}} color="error" aria-label="add" disabled={isSubmitting || isLoading}
                                        type="button" onClick={()=>{toast.error("Complete la data");console.log(errors)}} className="hooverButtonsubmit">
                                        {isLastStep() ? intl.formatMessage({id: "button_process"}) : intl.formatMessage({id: "button_next"})}
                                        <ArrowForward sx={{mr: 1}} className="hooverButtonRedsvgsubmit"/>
                                    </Fab>
                                        </>:<>
                                        <Fab style={{paddingLeft:"25px"}} variant="extended" color="error" aria-label="add" disabled={isSubmitting || isLoading}
                                         type="submit" className="hooverButtonsubmit">
                                        {isLastStep() ?  intl.formatMessage({id: "button_process"}) : intl.formatMessage({id: "button_next"})}
                                        <ArrowForward sx={{mr: 1}} className="hooverButtonRedsvgsubmit"/>
                                    </Fab>
                                        </>}
                                </div>
                            </Item>
                        </Form>
                    </>
                )}
            </Formik>
        </div>
    );
}